import React from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import useSev2ProjectCombobox from './hooks';

export const Sev2ProjectComboboxSchema = {
  uiOptions: {
    type: 'object',
    properties: {
      title: { type: 'string', title: 'Title', default: 'Project' },
      description: {
        type: 'string',
        title: 'Description',
        default: 'Select a project',
      },
    },
  },
  returnValue: { type: 'object' },
};

export const Sev2ProjectCombobox = (
  props: FieldExtensionComponentProps<
    { name?: string; phid?: string },
    { title: string; description: string }
  >,
) => {
  const { onChange, rawErrors, required, formData, uiSchema } = props;

  const { loading, open, setOpen, options, searchProjects } =
    useSev2ProjectCombobox();

  return (
    <FormControl
      margin="normal"
      required={required}
      error={rawErrors?.length > 0 && !formData}
    >
      <Autocomplete
        id="combo-box-project"
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        onInputChange={(_, value) => {
          searchProjects(value);
        }}
        onChange={(_, value) => {
          onChange({ name: value?.fields?.name, phid: value?.phid });
        }}
        getOptionSelected={(option, value) => option.phid === value.phid}
        getOptionLabel={option => option.fields.name}
        options={options}
        loading={loading}
        renderInput={params => (
          <TextField
            {...params}
            label={uiSchema?.['ui:options']?.title}
            variant="standard"
            helperText={uiSchema?.['ui:options']?.description}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </FormControl>
  );
};
